import { render } from "./FishForm.vue?vue&type=template&id=2d80e860&scoped=true&ts=true"
import script from "./FishForm.vue?vue&type=script&lang=ts"
export * from "./FishForm.vue?vue&type=script&lang=ts"

import "./FishForm.vue?vue&type=style&index=0&id=2d80e860&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d80e860"]])

export default __exports__